const ADD_COUNT_USER = 'ADD_COUNT_USER';
const ADD_COUNT_COMPUTER = 'ADD_COUNT_COMPUTER';

export const addCountUserAction = (payload) => ({
  type: ADD_COUNT_USER,
  payload,
});
export const addCountComputerAction = (payload) => ({
  type: ADD_COUNT_COMPUTER,
  payload,
});
